import React from "react";
import { useSelector } from "react-redux";
import { Route } from "react-router-dom";
import { RedirectAs404 } from "../utils/Utils";

export const ProtectedRoute = ({ exact, component: Component, allowedRights, ...rest }) => {
  const userRights = useSelector((state) => state.rights);
  const userHasAccess = allowedRights.some((value) => userRights.includes(value));
  return (
    <Route
      {...rest}
      exact
      render={(props) => (userHasAccess ? <Component {...props} {...rest} /> : <Route component={RedirectAs404} />)}
    />
  );
};
